import { render, staticRenderFns } from "./global_default_policy.vue?vue&type=template&id=b11a94ca&"
import script from "./global_default_policy.vue?vue&type=script&lang=js&"
export * from "./global_default_policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./global_default_policy.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports